import { colors } from '../../colors';
var jumplink = {
  bgColor: colors.white,
  borderColor: colors.overcast,
  linkColor: colors.dirtyBlue
};
export default jumplink;